export default "__VITE_ASSET__DvoBJgOc__"